import { Select } from '@/components/ui'
import { useMuscles } from '@/pages/workouts/api'

export function MuscleSelect({
  value, onChange, label = 'Группа мышц', placeholder = 'Все группы',
}: {
  value: string
  onChange: (value: string) => void
  label?: string
  placeholder?: string
}) {
  const muscles = useMuscles()
  return (
    <Select
      label={label}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      options={(muscles.data ?? []).map((m) => ({ value: m.key, label: m.label_ru }))}
    />
  )
}
